import * as TicketActions from './../actions/ticket_actions';
import extend from 'lodash/extend';
import * as UserActions from './../actions/user_actions';
import moment from 'moment';
import * as _ from 'lodash'

export var Tickets = (state = {
    ticketsList: [],
    ticketsConverstion: [],
    status: [],
    exportData: []
    //creste var
}, action) => {
    switch (action.type) {
        case "@@redux/INIT": {
        }
        case 'persist/REHYDRATE': {
            if (action.payload && action.payload.Tickets) {
                action.payload.User.IsLoggingIn = false;
                return extend({}, state, action.payload.Tickets);
            } else {
                return state;
            }
        }
        case TicketActions.TICKETS_LIST: {
            return extend({}, state, { ticketsList: action.data.data });
        }
            break;
        case TicketActions.EXPORT_DATA_RESPONSE: {
            return extend({}, state, { exportData: action.data })
        }

        case TicketActions.TICKETS_CONVERSTION: {
                      
            return extend({}, state, { ticketsConverstion: action.data.data });
        }
            break;
        case TicketActions.TICKETS_CONVERSTION_REPLY: {


            return extend({}, state, { ticketsConverstion: action.data.data, status: null });
        }
            break;
        case TicketActions.TICKETS_STAUTS: {
            return extend({}, state, { status: action.data });
        }
            break;
        case TicketActions.CHANGE_STATUS_TO_NULL: {
            return extend({}, state, { status: null });
        }
            break;
        case UserActions.USER_LOG_OUT: {

            return extend({}, state, {
                ticketsList: [],
                ticketsConverstion: [],
                status: []
            })
        }
            break;
        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/tickets_reducer.js
 **/